import { getSelectedCategoryName } from '../helpers/get-selected-category-name.js';

function initializeEventDetails() {
	const categoryName = getSelectedCategoryName(this.formElement);

	const labelElement = this.currentStepElement.querySelector('label[for="quote-request-event-details"]');
	const inputElement = this.currentStepElement.querySelector('textarea[name="event_details"]');
	if (categoryName) {
		labelElement.dataset.originalText = labelElement.textContent;
		inputElement.dataset.originalPlaceholder = inputElement.placeholder;
		labelElement.textContent = `What should your ${categoryName} know about the event?`;
		inputElement.placeholder = `Anything you need to let the ${categoryName} know`;
	} else if (labelElement.dataset.originalText) {
		labelElement.textContent = labelElement.dataset.originalText;
		inputElement.placeholder = inputElement.dataset.originalPlaceholder;
	}
}

export {
	initializeEventDetails
}